//React Related & Redux
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Lottie from "lottie-react";
//redux
import { useDispatch, useSelector } from "react-redux";
//MUI
import { withStyles } from "@material-ui/core/styles";
import MuiAlert from "@material-ui/lab/Alert/Alert";
import Snackbar from "@material-ui/core/Snackbar/Snackbar";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";
//My Components
import WideLayout from "../../layouts/WideLayout";
import FinalFactorGenerator from "../../components/FactorGenerator/FinalFactorGenerator";
import animationData from "../../assets/animation/error.json";
import successData from "../../assets/animation/success.json";

const StyledPaper = withStyles({
    root: {
        backgroundColor: "transparent",
        position: "relative",
        boxShadow: "none",
        paddingTop: "0",
    },
})(Paper);

const LimitedBackdrop = withStyles({
    root: {
        backgroundColor: "rgb(0, 0, 0,0.2)",
        height: "105%",
        position: "absolute",
        zIndex: 1,
        color: "#fff",
        borderRadius: "10px",
        marginTop: "-10px",
    },
})(Backdrop);

export function Alert(props) {
    return <MuiAlert elevation={6} severity="success" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    noBoxShadow: {
        boxShadow: "none",
    },
    container: {
        [theme.breakpoints.up("lg")]: {
            width: 1234,
        },
    },
    pad: {
        padding: "0 60px",
        [theme.breakpoints.down("sm")]: {
            padding: "0 20px",
        },
        [theme.breakpoints.down("xs")]: {
            padding: "0 0px",
        },
    },
    base: {
        flexGrow: 1,
        marginTop: "24px",
    },
    grayBox: {
        backgroundColor: "#f2f2f2",
        paddingTop: "30px",
    },
    textArea: {
        padding: "10px",
        borderRadius: "10px",
        backgroundColor: "#fff",
    },
    whiteBox: {
        backgroundColor: "#ffffff",
    },
    paperNoBg: {
        backgroundColor: "transparent",
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: "left",
        color: theme.palette.text.secondary,
    },
    stepLabel: {
        fontWeight: "700",
    },
    btnAdd: {
        backgroundColor: "#fff",
        paddingTop: "10px",
        paddingBottom: "10px",
        fontWeight: "bold",
        color: "#3B3B3B",
        "&:hover": {
            backgroundColor: "#fff",
            paddingTop: "10px",
            paddingBottom: "10px",
        },
    },

    root: {
        display: "flex",
    },
    OutlinedDiv: {
        backgroundColor: "transparent",
        margin: "0,30px",
    },
    back: {
        width: "140px",
        backgroundColor: "#ffa000",
        fontWeight: "700",
        color: "#fff",
        "&:hover": {
            backgroundColor: "#b28704",
        },
    },
    btnNext: {
        display: "block",
        minWidth: "140px",
        backgroundColor: "#28a504",
        fontWeight: "700",
        color: "#fff",
        "&:hover": {
            backgroundColor: "#417557",
        },
    },
    img: {
        width: "130px",
        [theme.breakpoints.down("xs")]: {
            width: "100px",
        },
    },
    margin: {
        margin: "0px 10px 0px 10px",
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: "100%",
    },
    textWhite: {
        backgroundColor: "#fff",
    },
    btnInline: {
        display: "inline",
    },
    btnSave: {
        display: "inline",
        width: "172px",
        backgroundColor: "#28a504",
        marginLeft: "21px",
        fontWeight: "700",
        "&:hover": {
            backgroundColor: "#417557",
        },
    },
    smCenter: {
        [theme.breakpoints.down("sm")]: {
            textAlign: "center",
            width: "fit-content",
        },
    },
    textSm: {
        [theme.breakpoints.down("xs")]: {
            textAlign: "center",
            fontSize: "12px",
        },
    },
    inputNumber: {
        border: "none",
        width: "50px",
        textAlign: "center",
        fontSize: "17px",
        background: "#fff",
        paddingTop: "10px",
        [theme.breakpoints.down("xs")]: {
            width: "25px",
        },
    },
}));

function getSteps(loggedIn = false) {
    return [
        "تایید اقلام سفارش",
        "نحوه تحویل و مشخصات تحویل گیرنده",
        "پیش فاکتور",
        "تسویه حساب",
    ];
}

const Factor = ({ history, match }) => {
    //Public Consts
    const classes = useStyles();
    const [staticText, setStaticText] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [factorData, setFactorData] = useState({});
    const dispatch = useDispatch();
    //end tmp
    //page related consts
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const Authority = params.get("Authority");
    const Status = params.get("Status");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isAlert, setIsAlert] = React.useState({
        type: "error",
        open: false,
        msg: "",
    });

    const cart = useSelector((state) => state.cart);
    const { cartItems } = cart;
    const steps = getSteps();
    const [activeStep, setActiveStep] = React.useState(4);
    //funcs
    const handleAlert = (open, msg) => {
        setIsAlert({
            open: open,
            type: "fail",
            msg: msg,
        });
    };
    const bread = [
        { title: "صفحه اصلی", to: "/" },
        { title: "فاکتور سفارش", to: "/" },
    ];

    const sendAxios = async (body) => {
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.post(
                "/api/invoices/payCheck",
                { paymentToken: Authority },
                config
            );
            if (data.status === "ok") {
                setFactorData(data.data);
                setLoading(false);
            } else {
                setError(true);
            }
        } catch (e) {
            console.log(e);
            setLoading(false);
        }
    };
    useEffect(() => {
        if (Status === "NOK") {
            setError(true);
        } else {
            sendAxios();
        }
    }, []);
    return (
        <>
            <WideLayout showBreadcrumbs={false}>
                {error && (
                    <>
                        <Grid item md={12} sm={12} xs={12} style={{ textAlign: "center" }}>
                            <Box
                                borderRadius="30px"
                                display="flex"
                                textAlign="center"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Lottie
                                    loop={true}
                                    autoplay={true}
                                    animationData={animationData}
                                    style={{
                                        width: "400px",
                                        height: "400px",
                                        margin: "0 auto",
                                    }}
                                />
                            </Box>
                        </Grid>
                        <Grid item md={12} sm={12} xs={12}>
                            <Box
                                color="#950000"
                                style={{ textAlign: "center" }}
                                fontSize={24}
                            >
                                فرایند انجام پرداخت با خطا مواجه شده است
              </Box>
                        </Grid>
                        <Grid item md={12} sm={12} xs={12}>
                            <Box color="#950000" style={{ textAlign: "center" }} mt={2}>
                                <Link to="/profile/unpaid-invoices">
                                    <Button variant="outlined" color="secondary">
                                        بازگشت
                  </Button>
                                </Link>
                            </Box>
                        </Grid>
                    </>
                )}
                {loading && !error && (
                    <Box
                        height="60vh"
                        display="flex"
                        width="100%"
                        justifyContent="center"
                        alignItems="center"
                        textAlign="center"
                    >
                        <CircularProgress style={{ margin: '0 auto' }} size={50} />
                    </Box>
                )}

                {!error && !loading && (
                    <>
                        <Grid
                            container
                            className={classes.base}
                            justify="center"
                            alignItems="center"
                        >
                            <Grid
                                justify="center"
                                alignItems="top"
                                className={classes.container}
                                container
                                spacing={1}
                            >
                                <Grid item md={12}>
                                    <Paper elevation={0}>
                                        <div>
                                            <Stepper activeStep={activeStep} alternativeLabel>
                                                {steps.map((label, index) => (
                                                    <Step key={label}>
                                                        <StepLabel className={classes.stepLabel}>
                                                            {label}
                                                        </StepLabel>
                                                    </Step>
                                                ))}
                                            </Stepper>
                                        </div>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12}>
                                    <Paper elevation={0} className={classes.paperNoBg}>
                                        <Box m={1} px={1} mb={2}>
                                            <Lottie
                                                loop={false}
                                                autoplay={true}
                                                animationData={successData}
                                                style={{
                                                    width: "300px",
                                                    height: "300px",
                                                    margin: "0 auto",
                                                }}
                                            />
                                            <Alert
                                                style={{
                                                    width: "400px",
                                                    margin: "0 auto",
                                                    boxShadow: "none",
                                                    textAlign: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                پرداخت شما با موفقیت انجام شد
                      </Alert>
                                        </Box>
                                        <Box
                                            boxShadow={1}
                                            p={{ xl: 2, lg: 2, md: 2, sm: 0.5, xs: 0 }}
                                            m={1}
                                            borderColor="#f2f2f2"
                                            border={1}
                                            borderRadius={16}
                                            className={
                                                activeStep <= 1
                                                    ? classes.grayBox + " cart"
                                                    : `cart ${classes.noBoxShadow}`
                                            }
                                        >
                                            <Box
                                                borderRadius={10}
                                                bgcolor="#950000"
                                                p={1.5}
                                                fontWeight="bold"
                                                color="#fff"
                                            >
                                                {" "}
                        جزئیات فاکتور
                      </Box>
                                            <FinalFactorGenerator factor={factorData} />
                                        </Box>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Grid>
                    </>
                )}
            </WideLayout>
            <Snackbar
                open={isAlert.open}
                autoHideDuration={3300}
                onClose={() => handleAlert(false, isAlert.msg)}
            >
                <Alert>&nbsp;{isAlert.msg}</Alert>
            </Snackbar>
        </>
    );
};

export default Factor;
